import { AxiosInstance } from 'axios';

const getSpaceServices = ({ GateWayInstance }: { GateWayInstance: AxiosInstance }) => ({
  // 判断当前账号是否有企业空间控制台权限
  checkSpacePermission() {
    return GateWayInstance.get<{ result: boolean }>('/spaces/permission');
  },
});

export default getSpaceServices;
